
    export default {
        layout: 'error',
    };
